import React, { useEffect, useRef, useState } from 'react';
import { Button, Label, Tooltip } from 'reactstrap';
import { includes } from 'lodash';
import Breadcrumbs from '../../components/Breadcrumb';
import './fulfillment.css';
import FulFillmentTableRow from '../../components/FulFillment/FulFillmentTableRow';
import Toggle from '../../components/Toggle';

export default function Fulfillment() {
  const obj = [{ id: 0 }];
  const [isSelected, setIsSelected] = useState(false);
  const [addNewRow, setAddNewRow] = useState(obj);
  const [selectedRow, setSelectedRow] = useState([]);
  const tableBody = useRef(null);
  const [inputFocus, setInputFocus] = useState(false);
  const [hotKeysToggle, setHotKeysToggle] = useState(false);
  const [checklastRow, setChecklastRow] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleClearSelected = () => {
    if (addNewRow?.length === selectedRow?.length) {
      setSelectedRow([]);
      setAddNewRow(obj);
      setIsSelected(false);
      setChecklastRow(true);
    } else if (addNewRow?.length > 1 || selectedRow?.length < addNewRow?.length) {
      const newRows = addNewRow.filter(item => !selectedRow.includes(item.id));
      setAddNewRow(newRows);
      setSelectedRow([]);
      setIsSelected(false);
    } else {
      setAddNewRow(obj);
    }
  };

  const handleClearAllRows = () => {
    setChecklastRow(true);
    setAddNewRow(obj);
    setIsSelected(false);
    setSelectedRow([]);
  };

  const setIsSelectedValue = e => {
    setIsSelected(e.target.checked);
    const AllRows = addNewRow
      ?.filter(item => item?.id !== includes(isSelected))
      .map(item => item.id);
    setSelectedRow(AllRows);
  };

  const handleAddNewRow = () => {
    const newItem = addNewRow[addNewRow.length - 1];
    setAddNewRow([...addNewRow, { id: newItem?.id + 1 }]);
  };

  const DeleteLastRow = () => {
    let removeLastRow = addNewRow.pop();
    removeLastRow = addNewRow?.filter(items => items?.id !== removeLastRow?.id);
    setAddNewRow(removeLastRow);
  };

  const handleKeyDown = e => {
    if (hotKeysToggle && !inputFocus) {
      if (e.ctrlKey && e.key === 'd') {
        handleClearAllRows();
      } else if (e.key === 'd' && addNewRow?.length > 1) {
        DeleteLastRow();
      } else if (e.key === 'a') {
        handleAddNewRow();
      }
      e.preventDefault();
    }
  };

  const handlHotkeysToggle = () => {
    setHotKeysToggle(!hotKeysToggle);
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  });

  const toggleTooltipM = () => setTooltipOpen(!tooltipOpen);

  return (
    <div>
      <div className="filter-section">
        <div className="fulfill-header">
          {/* <div>
            <Breadcrumbs />
          </div> */}
          <div className="fulfill-header-btns">
            <Button color="primary " className="fulfill-btn" onClick={handleClearSelected}>
              Clear Selected
            </Button>
            <Button onClick={handleClearAllRows} className="fulfill-btn" color="primary">
              Clear All
            </Button>
            <Button onClick={handleAddNewRow} className="fulfill-btn" color="primary">
              Add New Row
            </Button>
            <div className="hot-keys-toggle fulfill-btn">
              <Label className="fulfill-label">Hot keys</Label>
              <div id="pricing-toggle-M">
                <Toggle
                  className="fulfill-toggle"
                  value={hotKeysToggle}
                  onToggle={handlHotkeysToggle}
                />
              </div>
              <Tooltip
                placement="bottom"
                isOpen={tooltipOpen}
                target="pricing-toggle-M"
                toggle={toggleTooltipM}
              >
                <div>
                  <b>
                    <i>a </i>
                  </b>
                  to add a row
                </div>
                <div>
                  <b>
                    <i>d </i>
                  </b>
                  to delete last row
                </div>
                <div>
                  <b>
                    <i>ctrl + d </i>
                  </b>
                  to delete all rows
                </div>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
      <div className="viewContainer">
        <div className="table-header-fixed">
          <table>
            <thead className=" full-filltable-header">
              <tr className="full-filltable-row">
                <th className="pl-3">
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={e => setIsSelectedValue(e)}
                  />
                </th>
                <th>Loc</th>
                <th>Serial Number</th>
                <th>Online</th>
                <th>Activated</th>
                <th>Firmware Update</th>
                <th>SIM 1 Activation</th>
                <th>SIM 1 Carrier</th>
                <th>SIM 1 Online</th>
                <th>SIM 2 Activation</th>
                <th>SIM 2 Carrier</th>
                <th>SIM 2 Online</th>
                <th>Power Cycle</th>
              </tr>
            </thead>
            <tbody ref={tableBody} className="full-filltable-Body">
              {addNewRow?.map(item => (
                <FulFillmentTableRow
                  key={item?.id}
                  isAllSelected={isSelected}
                  item={item}
                  setSelectedRow={setSelectedRow}
                  selectedRow={selectedRow}
                  setInputFocus={setInputFocus}
                  checklastRow={checklastRow}
                  setChecklastRow={setChecklastRow}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
